import { RightOutlined } from '@ant-design/icons';
import { paymentGatewayFields } from './PaymentGateway';
import { wireFields } from './Wire';
import { linkSolutionFields } from './PaymentLink';
import { eduFields } from './Edu';

export const commericalFields = {
  'Payment Gateway': paymentGatewayFields,
  'Payment Link': linkSolutionFields,
  Wire: wireFields,
  'Forms & Feesbuzz': eduFields
};
export const customExpandIcon = ({ isActive }) => (
  <RightOutlined rotate={isActive ? 90 : 0} style={{ color: 'var(--color-primary)' }} />
);
